import { render, staticRenderFns } from "./HomeRecommend.vue?vue&type=template&id=22f920cd&scoped=true&"
import script from "./HomeRecommend.vue?vue&type=script&lang=js&"
export * from "./HomeRecommend.vue?vue&type=script&lang=js&"
import style0 from "./HomeRecommend.vue?vue&type=style&index=0&id=22f920cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f920cd",
  null
  
)

export default component.exports